import { createFileRoute, Outlet } from '@tanstack/react-router';

import { UserRole } from '@/modules/api/backend';

export const Route = createFileRoute('/_authenticated/management/organizations')({
  component: Outlet,
  beforeLoad: ({ context }) => ({
    breadcrumb: context.user?.role === UserRole.ADMIN ? 'Alle' : null,
  }),
});
